import { render, staticRenderFns } from "./OrderBase.vue?vue&type=template&id=fcc62a4a"
import script from "./OrderBase.vue?vue&type=script&lang=js"
export * from "./OrderBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports